<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0" v-if="user">
              {{user.username}}
            </p>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/user.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item @click="$bvModal.show('modal-logout')" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

<!--    <nav-filters v-if="user && filters"></nav-filters>-->
    <b-modal id="modal-logout" title="Logout Challenge" hide-footer hide-header-close>
      <logout-challenge @logout="logOutUser($event)"></logout-challenge>
    </b-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue';
  import LogoutChallenge from '@/components/logout/LogoutChallenge.vue';
  // import NavFilters from '../../components/chartFilters/NavFilters.vue';

  export default {
    components: {
      // Navbar Components
      DarkToggler,
      LogoutChallenge,
      // NavFilters,
    },
    props: {
      toggleVerticalMenuActive: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
      }),
    },
    methods: {
      logOutUser(value) {
        this.$bvModal.hide('modal-logout');
        if (value) {
          this.$store.dispatch('auth/clearLocalUser');
          this.$store.commit('stats/SET_LOADED', false);
          this.$router.push('/login');
        }
      },
    },
  }
</script>
